import { useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Label } from "../../../../components/ui/label";
import Select from "../../../../components/shared/inputs/Select";
import Form from "../../../../components/shared/Form";

const getId = (column: any) => column.name ?? column.accessorKey ?? column.id;

const getHeader = (column: any) => {
    if (column.label !== undefined) return column.label;
    return typeof column.header === "function" ? column.header(column) : column.header;
};

function SortInput({ columns }: any) {
    const { t } = useTranslation();
    const { control } = useFormContext();
    const cols = useWatch({ control, name: "columns" });
    const defaultSort = useWatch({ control, name: "defaultSort" });
    const hidden = useMemo(() => {
        if (!cols) return [];
        return cols
            .filter((column: any) => column.hideCompletely || column.hideSort)
            .map((column: any) => column.accessor);
    }, [cols]);

    const options = useMemo(() => {
        return columns?.filter((column: any) => {
            const id = getId(column);
            if (!id || ["actions", "selection"].includes(id)) return false;
            if (hidden.includes(id)) return false;
            return column.enableSorting !== false;
        });
    }, [columns, hidden]);

    return (
        <div className="tw-flex tw-flex-col tw-mb-4">
            <Label className="tw-mb-3">
                {t("default-sort")}
            </Label>

            <div className="tw-flex tw-items-center tw-gap-2 tw-w-full">
                <div className="tw-flex-1 tw-min-w-0">
                    <Form.Field name="defaultSort.field">
                        <Select placeholder={t("field")} allowClear>
                            {options?.map((column: any) => {
                                const id = String(getId(column));

                                return (
                                    <Select.Item key={id} value={id}>
                                        {getHeader(column)}
                                    </Select.Item>
                                );
                            })}
                        </Select>
                    </Form.Field>
                </div>

                {defaultSort?.field && (
                    <div className="tw-flex-1 tw-min-w-0">
                        <Form.Field name="defaultSort.type">
                            <Select placeholder={t("order")}>
                                <Select.Item value="asc">
                                    {t("asc")}
                                </Select.Item>
                                <Select.Item value="desc">
                                    {t("desc")}
                                </Select.Item>
                            </Select>
                        </Form.Field>
                    </div>
                )}
            </div>
        </div>
    );
}

export default SortInput;
